import React from "react";
import { Link } from "react-router-dom";
import {
    Card,
    Box,
    Grid,
    Typography,
    Chip,
} from "@mui/material";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const ExploreCard = ({
    customerData,
    status,
    journeyRoute,
    tagId,
    variant = "card",
    showFirstContact = false,
    showKnownSince = false,
    showLastContact = true,
    width = "23rem",
    onAddInteraction,
}) => {

    return (
    
            <Card
                sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    width: "100%",
                    maxWidth: "100%",
                    mb: 2,
                    transition: "0.3s",
                    borderLeft: `8px solid ${status.border}`,
                    border: "1px solid #E5E7EB",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                    "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    },
                }}
            >

                {/* Header */}

                <Box
                    sx={{
                        background: `linear-gradient(90deg, ${status.border}, ${status.border})`,
                        color: "#fff",
                        p: 2,
                    }}
                >

                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="center"
                    >

                        <Grid item>

                            <Box display="flex" alignItems="center">

                                <AccountCircleOutlinedIcon />
                                  <Link
                                    to={`/user/findcontact/${journeyRoute}/${tagId}/${customerData.external_id}?name=${encodeURIComponent(
                                        customerData.username
                                    )}`}
                                    target="_blank"
                                    style={{
                                        color: "#fff",
                                        textDecoration: "none",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            ml: 1,
                                            fontWeight: 600,
                                        }}
                                        variant="subtitle1"
                                    >
                                        {customerData.username || customerData.customer}
                                    </Typography>
                                </Link>
                            </Box>

                        </Grid>

                        <Grid item>

                            <Chip
                                label={`⭐ ${customerData.engagement_score || 0}`}
                                sx={{
                                    background: "#fff",
                                    color: "#009688",
                                    fontWeight: "bold",
                                }}
                            />

                        </Grid>

                    </Grid>

                </Box>

                {/* Statistics */}

                {variant === "card" && (
                <>

                <Grid
                    container
                    spacing={2}
                    sx={{ p: 2 }}
                >

                    <Grid item xs={6}>

                        <Box
                            sx={{
                                textAlign: "center",
                                borderRadius: 2,
                                background: "#F8FAFC",
                                p: 1,
                            }}
                        >

                            <GroupOutlinedIcon color="primary" />

                            <Typography
                                variant="caption"
                                display="block"
                            >
                                Interactions
                            </Typography>

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: 0.5,
                                }}
                            >
                                <Typography fontWeight="bold">
                                    {customerData.interaction_count}
                                </Typography>

                                <Tooltip title="Add Interaction">
                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={() => onAddInteraction?.(customerData)}
                                        sx={{
                                            p: 0.2,
                                        }}
                                    >
                                        <AddCircleOutlineIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </Box>

                        </Box>

                    </Grid>

                    <Grid item xs={6}>

                        <Box
                            sx={{
                                textAlign: "center",
                                borderRadius: 2,
                                background: "#F8FAFC",
                                p: 1,
                            }}
                        >

                            <VisibilityOutlinedIcon color="primary" />

                            <Typography
                                variant="caption"
                                display="block"
                            >
                                Views
                            </Typography>

                            <Typography fontWeight="bold">
                                {customerData.customer_views || 0}
                            </Typography>

                        </Box>

                    </Grid>

                </Grid>
                </>
                )}

                {/* Footer */}
                {variant === "card" && (
                <Box
                    sx={{
                        px: 2,
                        pb: 2,
                    }}
                >

                    {showLastContact && (
                        <>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                            >
                                Last Contact
                            </Typography>

                            <Typography
                                fontWeight="600"
                                mb={2}
                            >
                                {customerData.update_date
                                    ? new Date(customerData.update_date).toLocaleDateString(
                                          "en-GB",
                                          {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                          }
                                      )
                                    : "-"}
                            </Typography>
                        </>
                    )}

                    {(showFirstContact || showKnownSince) && (
                        <>
                            <Typography
                                variant="body2"
                                color="text.secondary"
                            >
                                {showKnownSince ? "Known Since" : "First Contact"}
                            </Typography>

                            <Typography fontWeight="600">
                                {showKnownSince
                                    ? customerData.known_since || "No Data"
                                    : customerData.first_contact_date
                                    ? new Date(
                                        customerData.first_contact_date
                                    ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                    })
                                    : "No Data"}
                            </Typography>

                            <Chip
                                label={status.label}
                                color={status.color}
                                size="small"
                                sx={{
                                    mt: 2,
                                    fontWeight: "bold",
                                }}
                            />
                        </>
                    )}

                </Box>
                )}

            </Card>

    );
};

export default ExploreCard;